import type { HistoricTaskInstance } from './history-types';

type NormalizedHistoricTaskState =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'DELETED';

type HistoricTaskStateInput = Pick<
  HistoricTaskInstance,
  'endTime' | 'deleteReason' | 'taskState'
>;

function normalizeFromTaskState(taskState: string): NormalizedHistoricTaskState | null {
  const state = taskState.trim().toLowerCase();

  if (state === 'completed') {
    return 'COMPLETED';
  }

  if (state === 'deleted') {
    return 'DELETED';
  }

  if (state === 'canceled' || state === 'cancelled') {
    return 'CANCELLED';
  }

  return null;
}

function normalizeFromDeleteReason(deleteReason: string): NormalizedHistoricTaskState {
  const reason = deleteReason.trim().toLowerCase();

  if (reason === 'completed') {
    return 'COMPLETED';
  }

  if (reason === 'deleted' || reason.includes('elimin')) {
    return 'DELETED';
  }

  return 'CANCELLED';
}

function normalizeHistoricTaskState(
  task: HistoricTaskStateInput,
): NormalizedHistoricTaskState {
  if (!task.endTime) {
    return 'IN_PROGRESS';
  }

  if (task.deleteReason) {
    return normalizeFromDeleteReason(task.deleteReason);
  }

  if (task.taskState) {
    const fromTaskState = normalizeFromTaskState(task.taskState);
    if (fromTaskState) {
      return fromTaskState;
    }
  }

  return 'COMPLETED';
}

export function getHistoricTaskStatePresentation(
  task: HistoricTaskStateInput,
) {
  const normalized = normalizeHistoricTaskState(task);

  switch (normalized) {
    case 'IN_PROGRESS':
      return {
        label: 'En curso',
        className: 'border-violet-300 bg-violet-100 text-violet-900',
      };
    case 'COMPLETED':
      return {
        label: 'Completada',
        className: 'border-emerald-300 bg-emerald-100 text-emerald-900',
      };
    case 'CANCELLED':
      return {
        label: 'Cancelada',
        className: 'border-rose-300 bg-rose-100 text-rose-900',
      };
    case 'DELETED':
      return {
        label: 'Eliminada',
        className: 'border-slate-300 bg-slate-100 text-slate-800',
      };
    default:
      return {
        label: 'Desconocido',
        className: 'border-gray-300 bg-gray-100 text-gray-800',
      };
  }
}
